import { Stack, Text } from '@mantine/core';

import { LayoutRow } from '@/shared/uikit/layouts/LayoutRow';

const About = () => (
	<LayoutRow
		title={{
			title: { children: 'О системе', size: 'h4', fw: 800 },
		}}
		type="once"
		style={{ height: 'calc(100vh - 116px)' }}
	>
		<Stack align="center">
			<Text size="md">
				Система предназначена для бронирования мест на парковке и рабочих мест в офисе.
			</Text>
			<Text size="md">
				Разработчик:{' '}
				<a href="https://f-soft.org/" target="_blank" rel="noreferrer">
					ООО «ФСОФТ»
				</a>
			</Text>
		</Stack>
	</LayoutRow>
);

export default About;
